(function(){"use strict";

/* ===== CONFIG ===== */
var CONFIG = {
  APPS_SCRIPT_URL: "https://script.google.com/macros/s/AKfycbzWHEcU694zakJX5dP_M5UWaiUhhYd0PUskkrv7NuPlAzQxzesfwufU-j9Jkjt8Mxo3-w/exec",
  SUBMIT_TOKEN: "ob-2026-9b3f7e2njsbibih7jdih7",
  PRICE_PER_TONNE: 6.99,
  ANNUAL_DISCOUNT: 0.17,
  MIN_PAYMENT: 1.00,
  CURRENCY: "GBP"
};

/* ===== EMISSION FACTORS ===== */
var EF = {
  elecGrid:0.207, elecGreen:0, gas:0.183, oil:0.247, lpg:0.214,
  petrolKm:0.170, dieselKm:0.172, hybridKm:0.105, electricKm:0.053,
  motorbike:0.084, bus:0.089, train:0.035, cycle:0, walk:0,
  shortFlight:0.156, longFlight:0.102, shortFlightDist:1500, longFlightDist:7200,
  diet:{"high-meat":3.3,"medium-meat":2.5,"low-meat":1.9,"pescatarian":1.7,"vegetarian":1.4,"vegan":1.0},
  treeAbsorb:0.022
};

/* ===== COUNTRIES ===== */
var COUNTRIES={"United Kingdom":5.2,"United States":14.9,"China":8.0,"India":1.9,"Germany":8.1,"France":4.7,"Japan":8.5,"Canada":14.3,"Australia":15.0,"Brazil":2.3,"Russia":11.4,"South Korea":11.6,"Italy":5.5,"Spain":5.1,"Mexico":3.6,"Indonesia":2.3,"Turkey":5.1,"Saudi Arabia":16.6,"South Africa":7.5,"Argentina":3.9,"Netherlands":8.3,"Poland":8.0,"Sweden":3.6,"Norway":7.5,"Ireland":7.7,"Belgium":8.2,"Switzerland":4.0,"Austria":6.8,"Denmark":5.1,"Finland":6.5,"Portugal":4.0,"Greece":5.7,"Czech Republic":9.3,"Romania":3.6,"New Zealand":6.2,"Singapore":8.9,"UAE":20.7,"Qatar":32.8,"Nigeria":0.6,"Kenya":0.4,"Egypt":2.3,"Thailand":3.6,"Vietnam":3.5,"Philippines":1.3,"Colombia":1.8,"Chile":4.3,"Pakistan":0.9,"Bangladesh":0.6,"Malaysia":7.6,"Israel":7.1,"Hong Kong":5.0,"Taiwan":11.2};

/* ===== HELPERS ===== */
function val(id){var el=document.getElementById(id);if(!el)return 0;if(el.tagName==="SELECT")return el.value;return parseFloat(el.value)||0;}
function sval(id){var el=document.getElementById(id);return el?el.value:"";}
function radioVal(name){var c=document.querySelector('input[name="'+name+'"]:checked');return c?c.value:null;}
function fmt(n){return n<0.01?"< 0.01":n.toFixed(2);}

function showResult(id, html) {
  var el = document.getElementById(id);
  if (!el) return;
  el.innerHTML = html;
  el.style.setProperty("display","block","important");
  el.scrollIntoView({behavior:"smooth",block:"nearest"});
}

function validateFields(fields, resultId) {
  var missing = [];
  for (var i = 0; i < fields.length; i++) {
    var f = fields[i];
    var el = document.getElementById(f.id);
    if (!el) continue;
    if (el.tagName === "SELECT") {
      if (!el.value || el.value === "") missing.push(f.label);
    } else {
      if (el.value === "" || el.value === undefined) missing.push(f.label);
    }
  }
  if (missing.length > 0) {
    showResult(resultId, '<div style="background:#1a1a2e;border-radius:16px;padding:32px;color:#fff;text-align:center;"><h3 style="color:#d4a843;margin-bottom:16px;">Please complete all fields</h3><p style="color:#ccc;">The following fields are required:</p><p style="color:#d4a843;margin-top:8px;">' + missing.join(', ') + '</p></div>');
    return false;
  }
  return true;
}

/* ===== RESULT CARD (tonnage calculators) ===== */
function resultCard(title, tonnes, breakdown, tip) {
  var treesNeeded = Math.ceil(tonnes / EF.treeAbsorb);
  var costYr = (tonnes * CONFIG.PRICE_PER_TONNE).toFixed(2);

  var h = '<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  h += '<h3 style="color:#fff;margin:0 0 6px;font-size:1.3rem;">' + title + '</h3>';
  h += '<div style="font-size:2.4rem;font-weight:700;color:#c8a86e;margin:10px 0;">' + fmt(tonnes) + ' <span style="font-size:1rem;font-weight:400;color:#bbb;">tonnes CO\u2082e / year</span></div>';
  if (breakdown) {
    h += '<div style="color:#ccc;font-size:0.95rem;margin-bottom:14px;">' + breakdown + '</div>';
  }
  h += '<div style="display:flex;gap:16px;margin-top:16px;flex-wrap:wrap;">';
  h += '<div style="flex:1;min-width:120px;background:#252525;border-radius:8px;padding:14px;text-align:center;"><div style="font-size:1.4rem;font-weight:700;color:#c8a86e;">' + treesNeeded + '</div><div style="font-size:0.8rem;color:#aaa;">trees to offset</div></div>';
  h += '<div style="flex:1;min-width:120px;background:#252525;border-radius:8px;padding:14px;text-align:center;"><div style="font-size:1.4rem;font-weight:700;color:#c8a86e;">\u00a3' + costYr + '</div><div style="font-size:0.8rem;color:#aaa;">est. offset cost/yr</div></div>';
  h += '</div>';
  if (tip) {
    h += '<div style="margin-top:16px;padding:12px 16px;background:#252525;border-left:3px solid #c8a86e;border-radius:4px;font-size:0.9rem;color:#ccc;">' + tip + '</div>';
  }
  h += '</div>';
  return h;
}

/* ===== SCORE CARD (quiz calculators) ===== */
function scoreCard(title, score, maxScore, breakdown, levels) {
  var pct = Math.round((score / maxScore) * 100);
  var level = "Needs Improvement";
  var lc = "#e74c3c";
  if (levels) {
    for (var i = 0; i < levels.length; i++) {
      if (pct >= levels[i].min) { level = levels[i].label; lc = levels[i].color; }
    }
  } else {
    if (pct >= 80) { level = "Excellent"; lc = "#c8a86e"; }
    else if (pct >= 60) { level = "Good"; lc = "#8bc34a"; }
    else if (pct >= 40) { level = "Fair"; lc = "#ff9800"; }
  }
  var h = '<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  h += '<h3 style="color:#fff;margin:0 0 6px;font-size:1.3rem;">' + title + '</h3>';
  h += '<div style="font-size:2.4rem;font-weight:700;color:' + lc + ';margin:10px 0;">' + score + ' <span style="font-size:1rem;font-weight:400;color:#bbb;">/ ' + maxScore + '</span></div>';
  h += '<div style="font-size:1.1rem;font-weight:600;color:' + lc + ';margin-bottom:14px;">' + level + '</div>';
  h += '<div style="background:#333;border-radius:6px;height:12px;overflow:hidden;margin:10px 0;"><div style="background:' + lc + ';height:100%;width:' + pct + '%;border-radius:6px;transition:width 1s;"></div></div>';
  if (breakdown) {
    h += '<div style="color:#ccc;font-size:0.95rem;margin-top:14px;">' + breakdown + '</div>';
  }
  h += '</div>';
  return h;
}

/* ===== PAYMENT PANEL ===== */
var panelCount = 0;
function paymentPanel(calculatorName, tonnes) {
  panelCount++;
  var pid = "pp" + panelCount;
  var basePrice = Math.max(CONFIG.MIN_PAYMENT, tonnes * CONFIG.PRICE_PER_TONNE);
  var monthlyPrice = Math.max(CONFIG.MIN_PAYMENT, basePrice / 12);
  var annualPrice = Math.max(CONFIG.MIN_PAYMENT, basePrice * (1 - CONFIG.ANNUAL_DISCOUNT));
  function gbp(n) { return '\u00a3' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* Inject styles into <head> so they never leak into emails */
    if (!document.getElementById('ob-panel-shared')) {
    var _s = document.createElement('style');
    _s.id = 'ob-panel-shared';
    _s.textContent = '@keyframes ob-spin{to{transform:rotate(360deg)}}'
      + '.ob-plan-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,140px),1fr));gap:10px;margin-bottom:20px;width:100%;box-sizing:border-box;}'
      + '@media(max-width:520px){.ob-plan-grid{grid-template-columns:1fr !important;gap:10px !important;}}';
    document.head.appendChild(_s);
  }
    (function(){
    var _s2 = document.createElement('style');
    _s2.textContent = '.' + pid + '-card{background:#252525;border:2px solid #444;border-radius:10px;padding:22px 10px 16px;cursor:pointer;text-align:center;transition:all 0.2s;min-width:0;box-sizing:border-box;position:relative;}.' + pid + '-card:hover{border-color:#888;transform:translateY(-2px);}.' + pid + '-card.sel{background:#2a2a2a;border-color:#c8a86e;box-shadow:0 0 16px rgba(200,168,110,0.25);}@media(max-width:600px){.' + pid + '-card{padding:20px 6px 12px !important;}.' + pid + '-card div[style*="font-size:1.6rem"]{font-size:1.1rem !important;}}';
    document.head.appendChild(_s2);
  })();

  var h = '';

  h += '<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:12px;">';
h += '<h3 style="color:#fff;margin:0 0 16px;font-size:1.15rem;text-align:center;">Choose Your Offset Plan</h3>';

/* First-month-free notice */
h += '<div style="background:#252525;border-left:3px solid #c8a86e;border-radius:4px;padding:10px 14px;margin-bottom:20px;font-size:0.8rem;color:#bbb;line-height:1.5;">';
h += '<strong style="color:#c8a86e;">First month free, today only:</strong> one per customer. Subject to our <a href="https://www.offsetbritain.org/policies/terms-of-service" target="_blank" style="color:#c8a86e;text-decoration:underline;">Terms of Service</a>. We reserve the right to refuse the offer where we detect abuse.';
h += '</div>';

/* Three plan cards */
h += '<div class="ob-plan-grid">';

  /* One-time */
  h += '<div class="' + pid + '-card" data-plan="one-time" id="' + pid + '-onetime" style="cursor:pointer;" role="button" tabindex="0">';
  h += '<div style="font-size:0.85rem;color:#aaa;margin-bottom:10px;">One-Time</div>';
  h += '<div style="font-size:1.6rem;font-weight:700;color:#c8a86e;">' + gbp(basePrice) + '</div>';
  h += '<div style="font-size:0.8rem;color:#777;margin-top:6px;">Single payment</div>';
  h += '</div>';

  /* Monthly (default) */
  h += '<div class="' + pid + '-card sel" data-plan="monthly" id="' + pid + '-monthly" style="position:relative;cursor:pointer;" role="button" tabindex="0">';
  h += '<div style="position:absolute;top:-11px;left:50%;transform:translateX(-50%);background:#c8a86e;color:#1a1a1a;padding:3px 10px;border-radius:10px;font-size:0.7rem;font-weight:700;white-space:nowrap;">RECOMMENDED</div>';
  h += '<div style="font-size:0.85rem;color:#aaa;margin-bottom:10px;margin-top:6px;">Monthly</div>';
  h += '<div style="font-size:1.6rem;font-weight:700;color:#c8a86e;">' + gbp(monthlyPrice) + '</div>';
  h += '<div style="font-size:0.8rem;color:#777;margin-top:6px;">1st month FREE, then per month</div>';
  h += '</div>';

  /* Annual */
h += '<div class="' + pid + '-card" data-plan="annual" id="' + pid + '-annual" style="position:relative;cursor:pointer;" role="button" tabindex="0">';
h += '<div style="position:absolute;top:-11px;left:50%;transform:translateX(-50%);background:#c8a86e;color:#1a1a1a;padding:3px 10px;border-radius:10px;font-size:0.7rem;font-weight:700;white-space:nowrap;">SAVE 17%</div>';
h += '<div style="font-size:0.85rem;color:#aaa;margin-bottom:10px;margin-top:6px;">Annual</div>';
  h += '<div style="font-size:1.6rem;font-weight:700;color:#c8a86e;">' + gbp(annualPrice) + '</div>';
  h += '<div style="font-size:0.8rem;color:#777;margin-top:6px;">Per year</div>';
  h += '</div>';

  h += '</div>';

  /* Email field */
  h += '<div style="margin-bottom:16px;">';
  h += '<label style="display:block;font-size:0.85rem;color:#aaa;margin-bottom:6px;">Email (for receipt and payment link)</label>';
  h += '<input type="email" id="' + pid + '-email" placeholder="your@email.com" style="width:100%;padding:12px 14px;border:1px solid #444;border-radius:8px;background:#252525;color:#fff;font-size:0.95rem;box-sizing:border-box;outline:none;" onfocus="this.style.borderColor=\'#c8a86e\'" onblur="this.style.borderColor=\'#444\'">';
  h += '</div>';

  /* Offset Now button */
  h += '<button type="button" id="' + pid + '-btn" style="display:block;width:100%;background:#c8a86e;color:#1a1a1a;border:none;padding:16px;border-radius:8px;font-size:1.05rem;font-weight:700;cursor:pointer;transition:background 0.2s;">Start Free Month (' + gbp(monthlyPrice) + '/mo after)</button>';

  /* Loading state */
  h += '<div id="' + pid + '-loading" style="display:none;text-align:center;padding:16px;">';
  h += '<div style="width:32px;height:32px;border:3px solid #333;border-top-color:#c8a86e;border-radius:50%;animation:ob-spin 0.8s linear infinite;margin:0 auto 10px;"></div>';
  h += '<div style="color:#aaa;font-size:0.9rem;">Connecting to secure checkout...</div>';
  h += '</div>';

  /* Error state */
  h += '<div id="' + pid + '-error" style="display:none;text-align:center;padding:12px;margin-top:8px;background:#2a1a1a;border:1px solid #e74c3c;border-radius:8px;color:#e74c3c;font-size:0.9rem;"></div>';

  h += '<div style="text-align:center;margin-top:12px;font-size:0.75rem;color:#555;">Secure payment via Stripe. You will receive an email receipt.</div>';
  h += '</div>';

  /* Wire up interactivity */
    setTimeout(function() {
    try {
    var selected = "monthly";
    var prices = {"one-time": basePrice, "monthly": monthlyPrice, "annual": annualPrice};
    var labels = {"one-time": gbp(basePrice), "monthly": "Start Free Month (" + gbp(monthlyPrice) + "/mo after)", "annual": gbp(annualPrice) + "/yr"};
    var cards = document.querySelectorAll("." + pid + "-card");
    var btn = document.getElementById(pid + "-btn");
    var loading = document.getElementById(pid + "-loading");
    var errorDiv = document.getElementById(pid + "-error");
    var emailInput = document.getElementById(pid + "-email");

    for (var i = 0; i < cards.length; i++) {
      (function(card) {
        card.addEventListener("click", function(e) {
          if (e && e.preventDefault) e.preventDefault();
          for (var j = 0; j < cards.length; j++) cards[j].classList.remove("sel");
          card.classList.add("sel");
          selected = card.getAttribute("data-plan");
          if (btn) btn.textContent = selected === "monthly" ? labels[selected] : "Offset Now - " + labels[selected];
        });
      })(cards[i]);
    }

    if (!btn) return;

    btn.addEventListener("click", function(e) {
      e.preventDefault();

      var email = emailInput ? emailInput.value.trim() : "";
      if (!email || email.indexOf("@") < 1) {
        errorDiv.textContent = "Please enter a valid email address.";
        errorDiv.style.display = "block";
        if (emailInput) { emailInput.style.borderColor = "#e74c3c"; emailInput.focus(); }
        return;
      }
      errorDiv.style.display = "none";
      btn.style.display = "none";
      loading.style.display = "block";

      /* ---- Stripe checkout ---- */
            var payload = {
        action: "createCheckout",
        token: CONFIG.SUBMIT_TOKEN,
        calculator: calculatorName,
        tonnes: parseFloat(tonnes.toFixed(4)),
        plan: selected,
        amount: parseFloat(prices[selected].toFixed(2)),
        currency: CONFIG.CURRENCY,
        email: email,
        consent: true,
        consentTimestamp: new Date().toISOString()
      };

      /* ---- Record calculator lead (fire-and-forget) ---- */
      fetch(CONFIG.APPS_SCRIPT_URL, {
        method: "POST",
        headers: {"Content-Type": "text/plain"},
          body: JSON.stringify({
          token: CONFIG.SUBMIT_TOKEN,
          source: "calculator",
          email: email,
          calculatorType: calculatorName.toLowerCase().indexOf("business") >= 0 ? "business" : "individual",
          tonnage: parseFloat(tonnes.toFixed(4)),
          monthlyCost: prices["monthly"].toFixed(2),
          annualCost: prices["annual"].toFixed(2),
          dailyCost: (prices["one-time"] / 365).toFixed(2),
          consent: true,
          consentTimestamp: new Date().toISOString(),
          sourcePage: window.location.href,
          calculatorInputs: payload,
          calculatorStatus: "complete"
        })
      }).catch(function(){});

      fetch(CONFIG.APPS_SCRIPT_URL, {
  method: "POST",
  headers: {"Content-Type": "text/plain"},
  body: JSON.stringify(payload)
})
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
        } else {
          throw new Error(data.error || "No checkout URL returned");
        }
      })
      .catch(function(err) {
        console.error("Offset payment error:", err);
        btn.style.display = "block";
        loading.style.display = "none";

        var raw = (err && err.message) ? String(err.message) : "";
        var lower = raw.toLowerCase();
        var friendly;

        if (lower.indexOf("email") !== -1 && (lower.indexOf("invalid") !== -1 || lower.indexOf("valid") !== -1)) {
          friendly = "That email address doesn't look right. Please check it and try again.";
        } else if (lower.indexOf("missing") !== -1 || lower.indexOf("required") !== -1) {
          friendly = "Some required details are missing. Please refresh the page and try again.";
        } else if (lower.indexOf("amount_too_large") !== -1 || lower.indexOf("amount too large") !== -1) {
          friendly = "That amount is too large to process. Please contact us at ai-request@offsetbritain.org.";
        } else if (lower.indexOf("amount_too_small") !== -1 || lower.indexOf("amount too small") !== -1) {
          friendly = "That amount is too small to process. Please increase your offset selection.";
        } else if (lower.indexOf("network") !== -1 || lower.indexOf("failed to fetch") !== -1) {
          friendly = "We couldn't reach the payment server. Check your connection and try again.";
        } else if (raw) {
          friendly = "Payment couldn't start: " + raw;
        } else {
          friendly = "Something went wrong. Please try again, or contact ai-request@offsetbritain.org.";
        }

        errorDiv.textContent = friendly;
        errorDiv.style.display = "block";
      });
        });
    } catch(err) { console.error("Payment panel setup error:", err); }
    }, 200);


  return h;
}

/* ===== SUGGESTED TONNES FOR SCORE CALCULATORS ===== */
function suggestedTonnes(type, score) {
  var t = 0;
  if (type === "esg") t = ((30 - score) / 30) * 10;
  else if (type === "eco") t = ((32 - score) / 32) * 5;
  else if (type === "office") t = ((28 - score) / 28) * 8;
  else if (type === "ppn") t = ((16 - score) / 16) * 15;
  return Math.max(0.5, t);
}

/* ===== CALCULATOR FUNCTIONS ===== */

function calcCarbon() {
  var e=val("calc-elec"),g=val("calc-gas"),c=val("calc-car"),f=sval("calc-fuel"),sf=val("calc-short-flights"),lf=val("calc-long-flights"),d=sval("calc-diet");
  var ck=c*1.60934;
  var ff={petrol:EF.petrolKm,diesel:EF.dieselKm,hybrid:EF.hybridKm,electric:EF.electricKm};
  var cE=(ck*((f?ff[f]:0)||0))/1000;
  var eE=(e*EF.elecGrid)/1000;
  var gE=(g*EF.gas)/1000;
  var fE=((sf*EF.shortFlight*EF.shortFlightDist)+(lf*EF.longFlight*EF.longFlightDist))/1000;
  var dE=(d?EF.diet[d]:0)||0;
  var t=eE+gE+cE+fE+dE;
  var bd="Home energy: "+fmt(eE+gE)+"t | Transport: "+fmt(cE)+"t | Flights: "+fmt(fE)+"t | Diet: "+fmt(dE)+"t";
  var tip=t>5.5?"Your footprint is above the UK average. Switching to a green energy tariff could save "+fmt(eE)+"t immediately.":"Great! You are below the UK average. Offset the rest now.";
  showResult("calc-result", resultCard("Your Carbon Footprint",t,bd,tip) + paymentPanel("Carbon Footprint",t));
}

function calcHomeEnergy() {
  var e=val("home-elec"),et=sval("home-elec-type"),ht=sval("home-heat"),hk=val("home-heat-kwh"),p=val("home-people")||1;
  var ef=et==="green"?EF.elecGreen:EF.elecGrid;
  var hf={gas:EF.gas,oil:EF.oil,lpg:EF.lpg,electric:EF.elecGrid,none:0};
  var eT=(e*ef)/1000/p;
  var hT=(hk*(hf[ht]||EF.gas))/1000/p;
  var t=eT+hT;
  var bd="Electricity: "+fmt(eT)+"t | Heating: "+fmt(hT)+"t (per person)";
  var tip=ht==="gas"?"Gas heating accounts for most home emissions. Consider a heat pump to cut this by up to 75%.":"";
  showResult("home-result", resultCard("Home Energy Footprint",t,bd,tip) + paymentPanel("Home Energy",t));
}

function calcCommute() {
  var d=val("cm-dist"),dy=val("cm-days")||parseInt(sval("cm-days"))||0,m=sval("cm-mode"),w=val("cm-weeks")||0;
  var km=d*1.60934*2;
  var f={petrol:EF.petrolKm,diesel:EF.dieselKm,hybrid:EF.hybridKm,electric:EF.electricKm,motorbike:EF.motorbike,bus:EF.bus,train:EF.train,cycle:EF.cycle,walk:EF.walk};
  var pd=km*(f[m]||EF.petrolKm)/1000;
  var t=pd*dy*w;
  var bd=fmt(km)+" km return | "+dy+" days/wk | "+w+" weeks/yr";
  var tip=(m==="petrol"||m==="diesel")?"Switching to train could save "+fmt(t*0.8)+"t per year.":"";
  showResult("commute-result", resultCard("Commute Footprint",t,bd,tip) + paymentPanel("Commute",t));
}

function calcTrees() {
  var tn=val("tree-tonnes"),h=sval("tree-horizon");
  var y=h==="lifetime"?40:(parseInt(h)||1);
  var n=Math.ceil(tn/(EF.treeAbsorb*y));
  var html='<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  html+='<h3 style="color:#fff;margin:0 0 10px;font-size:1.3rem;">Trees Needed</h3>';
  html+='<div style="font-size:2.4rem;font-weight:700;color:#c8a86e;margin:10px 0;">'+n.toLocaleString()+' <span style="font-size:1rem;font-weight:400;color:#bbb;">trees</span></div>';
  html+='<div style="color:#ccc;font-size:0.95rem;">To absorb <strong>'+tn+' tonnes</strong> of CO\u2082 over <strong>'+(h==="lifetime"?"40 years (lifetime)":y+" year"+(y>1?"s":""))+'</strong></div>';
  html+='<div style="color:#ccc;font-size:0.85rem;margin-top:10px;">Each tree absorbs approximately 22 kg CO\u2082 per year on average.</div>';
  html+='</div>';
  showResult("tree-result", html + paymentPanel("Tree Planting", tn));
}

function calcBusiness() {
  var emp=val("biz-employees"),e=val("biz-elec"),g=val("biz-gas"),fl=val("biz-fleet"),fi=val("biz-flights"),fd=sval("biz-flight-dist")||"short";
  var eT=(e*EF.elecGrid)/1000;
  var gT=(g*EF.gas)/1000;
  var flT=fl*4.6;
  var fk=fd==="long"?EF.longFlightDist:EF.shortFlightDist;
  var fiT=(fi*EF[fd==="long"?"longFlight":"shortFlight"]*fk)/1000;
  var cT=emp*1.1;
  var t=eT+gT+flT+fiT+cT;
  var bd="Energy: "+fmt(eT+gT)+"t | Fleet: "+fmt(flT)+"t | Flights: "+fmt(fiT)+"t | Commuting: "+fmt(cT)+"t";
  showResult("biz-result", resultCard("Business Carbon Estimate",t,bd,"Businesses can claim tax relief on verified carbon offsets.") + paymentPanel("Business Offset",t));
}

function calcCompare() {
  var co2=val("co2-input");
  var items=[
    {label:"London-New York flights",val:(co2/0.99).toFixed(1)},
    {label:"miles driven (petrol)",val:Math.round(co2*1000/EF.petrolKm/1.60934).toLocaleString()},
    {label:"trees needed for 1 year",val:Math.ceil(co2/EF.treeAbsorb).toLocaleString()},
    {label:"UK homes powered (1 yr)",val:(co2/2.1).toFixed(1)},
    {label:"Amazon deliveries",val:Math.round(co2*1000/0.6).toLocaleString()},
    {label:"beef burgers",val:Math.round(co2*1000/3.1).toLocaleString()}
  ];
  var h='<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  h+='<h3 style="color:#fff;margin:0 0 16px;font-size:1.3rem;">'+co2+' tonnes CO\u2082 is equivalent to:</h3>';
  h+='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:12px;">';
  items.forEach(function(item){
    h+='<div style="background:#252525;border-radius:8px;padding:16px;text-align:center;">';
    h+='<div style="font-size:1.4rem;font-weight:700;color:#c8a86e;">'+item.val+'</div>';
    h+='<div style="font-size:0.8rem;color:#aaa;">'+item.label+'</div></div>';
  });
  h+='</div></div>';
  showResult("compare-result", h + paymentPanel("Compare Impact Offset", co2));
}

function calcCountry() {
  var c=sval("country-select");
  if (!c||!COUNTRIES[c]) return;
  var v=COUNTRIES[c];
  var uk=COUNTRIES["United Kingdom"];
  var sorted=Object.entries(COUNTRIES).sort(function(a,b){return b[1]-a[1];});
  var rank=sorted.findIndex(function(e){return e[0]===c;})+1;
  var h='<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  h+='<h3 style="color:#fff;margin:0 0 6px;font-size:1.3rem;">'+c+'</h3>';
  h+='<div style="font-size:2.4rem;font-weight:700;color:#c8a86e;margin:10px 0;">'+v+' <span style="font-size:1rem;font-weight:400;color:#bbb;">tonnes CO\u2082 per capita</span></div>';
  h+='<div style="color:#ccc;font-size:0.95rem;">#'+rank+' out of '+sorted.length+' countries | UK: '+uk+'t | '+(v>uk?(((v/uk-1)*100).toFixed(0)+'% higher'):(((1-v/uk)*100).toFixed(0)+'% lower'))+' than UK</div>';
  h+='<div style="margin:18px 0;">';
  var top5=sorted.slice(0,5);
  top5.forEach(function(e){
    var w=(e[1]/sorted[0][1]*100).toFixed(0);
    var isSel=e[0]===c;
    h+='<div style="margin:6px 0;"><div style="display:flex;justify-content:space-between;font-size:0.85rem;color:'+(isSel?'#c8a86e':'#aaa')+';">'+e[0]+'<span>'+e[1]+'t</span></div>';
    h+='<div style="background:#333;border-radius:4px;height:8px;overflow:hidden;"><div style="background:'+(isSel?'#c8a86e':'#555')+';height:100%;width:'+w+'%;border-radius:4px;"></div></div></div>';
  });
  h+='</div></div>';
  showResult("country-result", h + paymentPanel("Country Offset ("+c+")", v));
}

function calcEvent() {
  var at=val("ev-attendees"),dy=parseFloat(sval("ev-days"))||1,tm=parseFloat(sval("ev-travel"))||50,m=sval("ev-mode"),ca=sval("ev-catering"),ac=parseFloat(sval("ev-accom"))||0;
  var tk=tm*1.60934*2;
  var mf={car:EF.petrolKm,train:EF.train,mixed:0.1,flight:EF.shortFlight};
  var tT=(at*tk*(mf[m]||0.1))/1000;
  var cf={full:0.010,light:0.005,none:0};
  var cT=at*dy*(cf[ca]||0.008);
  var vT=dy*0.15;
  var aT=ac*at*0.019;
  var t=tT+cT+vT+aT;
  var bd="Travel: "+fmt(tT)+"t | Catering: "+fmt(cT)+"t | Venue: "+fmt(vT)+"t | Accommodation: "+fmt(aT)+"t";
  showResult("event-result", resultCard("Event Carbon Footprint",t,bd,"Event offsets can be included in your ESG reporting.") + paymentPanel("Event Offset",t));
}

function calcWedding() {
  var g=val("wd-guests"),tm=parseFloat(sval("wd-travel"))||50,v=sval("wd-venue"),f=sval("wd-food"),ac=parseFloat(sval("wd-accom"))||0,d=sval("wd-decor");
  var tT=(g*tm*1.60934*2*0.12)/1000;
  var vf={outdoor:0.2,small:0.5,large:1.2,destination:3.0};
  var vT=vf[v]||0.5;
  var ff={vegan:0.004,veggie:0.005,mixed:0.008,premium:0.012};
  var fT=g*(ff[f]||0.008);
  var aT=(g*ac/100)*0.019;
  var df={minimal:0.05,moderate:0.15,elaborate:0.35};
  var dT=df[d]||0.15;
  var t=tT+vT+fT+aT+dT;
  var bd="Travel: "+fmt(tT)+"t | Venue: "+fmt(vT)+"t | Food: "+fmt(fT)+"t | Accommodation: "+fmt(aT)+"t | Decor: "+fmt(dT)+"t";
  showResult("wedding-result", resultCard("Wedding Carbon Footprint",t,bd,"Offset Carbon for your wedding.") + paymentPanel("Wedding Offset",t));
}

function calcESG() {
  var t=0,a=0;
  for(var i=1;i<=10;i++){var v=radioVal("q"+i);if(v!==null){t+=parseInt(v);a++;}}
  if(a<10){showResult("esg-result",'<div style="background:#1a1a1a;color:#c8a86e;border-radius:12px;padding:20px;margin-top:16px;text-align:center;">Please answer all 10 questions to see your ESG score.</div>');return;}
  var levels=[{min:0,label:"Getting Started",color:"#e74c3c"},{min:30,label:"Developing",color:"#ff9800"},{min:50,label:"Progressing",color:"#8bc34a"},{min:70,label:"Advanced",color:"#4caf50"},{min:85,label:"Leading",color:"#c8a86e"}];
  var bd="Your organisation demonstrates "+(t>=21?"strong":t>=14?"developing":"early-stage")+" ESG practices.";
  var tonnes = suggestedTonnes("esg", t);
  showResult("esg-result", scoreCard("ESG Readiness Score",t,30,bd,levels) + paymentPanel("ESG Offset", tonnes));
}

function calcEco() {
  var t=0,a=0;
  for(var i=1;i<=8;i++){var v=radioVal("eq"+i);if(v!==null){t+=parseInt(v);a++;}}
  if(a<8){showResult("eco-result",'<div style="background:#1a1a1a;color:#c8a86e;border-radius:12px;padding:20px;margin-top:16px;text-align:center;">Please answer all 8 questions to see your Eco Score.</div>');return;}
  var levels=[{min:0,label:"Eco Beginner",color:"#e74c3c"},{min:30,label:"Eco Aware",color:"#ff9800"},{min:55,label:"Eco Friendly",color:"#8bc34a"},{min:75,label:"Eco Champion",color:"#4caf50"},{min:90,label:"Eco Hero",color:"#c8a86e"}];
  var bd=t>=24?"Outstanding! Low-impact lifestyle.":t>=16?"Good progress. Small changes could push you higher.":"Every step counts. Start with energy and transport.";
  var tonnes = suggestedTonnes("eco", t);
  showResult("eco-result", scoreCard("Your Eco Score",t,32,bd,levels) + paymentPanel("Eco Score Offset", tonnes));
}

function calcOffice() {
  var t=0,a=0;
  for(var i=1;i<=7;i++){var v=radioVal("oa"+i);if(v!==null){t+=parseInt(v);a++;}}
  if(a<7){showResult("audit-result",'<div style="background:#1a1a1a;color:#c8a86e;border-radius:12px;padding:20px;margin-top:16px;text-align:center;">Please answer all 7 questions to see your Office Audit result.</div>');return;}
  var levels=[{min:0,label:"Needs Attention",color:"#e74c3c"},{min:30,label:"Room to Improve",color:"#ff9800"},{min:55,label:"Good Practice",color:"#8bc34a"},{min:75,label:"Best Practice",color:"#4caf50"},{min:90,label:"Exemplary",color:"#c8a86e"}];
  var tonnes = suggestedTonnes("office", t);
  showResult("audit-result", scoreCard("Office Sustainability Score",t,28,"Your office sustainability indicates "+(t>=21?"strong":"developing")+" environmental management.",levels) + paymentPanel("Office Audit Offset", tonnes));
}

function calcPPN() {
  var t=0,a=0;var sc={yes:2,partial:1,no:0};
  for(var i=1;i<=8;i++){var v=radioVal("ppn"+i);if(v!==null){t+=(sc[v]||0);a++;}}
  if(a<8){showResult("ppn-result",'<div style="background:#1a1a1a;color:#c8a86e;border-radius:12px;padding:20px;margin-top:16px;text-align:center;">Please answer all 8 questions to check your PPN 006 compliance.</div>');return;}
  var mx=16;
  var pct=Math.round((t/mx)*100);
  var st=pct>=80?"Compliant":pct>=50?"Partially Compliant":"Non-Compliant";
  var sc2=pct>=80?"#c8a86e":pct>=50?"#ff9800":"#e74c3c";
  var h='<div style="background:#1a1a1a;color:#fff;border-radius:12px;padding:28px 24px;margin-top:16px;">';
  h+='<h3 style="color:#fff;margin:0 0 6px;font-size:1.3rem;">PPN 006 Compliance Check</h3>';
  h+='<div style="font-size:2rem;font-weight:700;color:'+sc2+';margin:10px 0;">'+st+'</div>';
  h+='<div style="font-size:1.1rem;color:#ccc;margin-bottom:14px;">Score: '+t+'/'+mx+' ('+pct+'%)</div>';
  h+='<div style="background:#333;border-radius:6px;height:12px;overflow:hidden;margin:10px 0;"><div style="background:'+sc2+';height:100%;width:'+pct+'%;border-radius:6px;transition:width 1s;"></div></div>';
  h+='<div style="color:#ccc;font-size:0.9rem;margin-top:14px;">'+(pct>=80?"Your organisation appears to meet PPN 006 requirements.":"You may need to strengthen your Carbon Reduction Plan.")+'</div>';
  h+='</div>';
  var tonnes = suggestedTonnes("ppn", t);
  showResult("ppn-result", h + paymentPanel("PPN Compliance Offset", tonnes));
}

/* ===== INIT ===== */
function populateCountries() {
  var s = document.getElementById("country-select");
  if (!s || s.options.length > 1) return;
  Object.keys(COUNTRIES).sort().forEach(function(c) {
    var o = document.createElement("option");
    o.value = c;
    o.textContent = c;
    s.appendChild(o);
  });
}

function fixColors() {
  var css = document.createElement("style");
  css.textContent = "#carbon-calc button,#home-calc button,#commute-tool button,#compare-tool button,#country-tool button,#tree-calc button,#biz-calc button,#eco-tool button,#esg-quiz button,#event-tool button,#wedding-tool button,#audit-tool button,#ppn-checker-tool button,.page-content button:not([id*=\'pp\']){background:#1a1a1a !important;color:#fff !important;border:none !important;padding:14px 32px !important;border-radius:8px !important;font-size:1rem !important;font-weight:600 !important;cursor:pointer !important;transition:background 0.2s,transform 0.1s !important;}.page-content button:hover{background:#333 !important;transform:translateY(-1px) !important;}[style*=\"background-color: #2d6a4f\"],[style*=\"background:#2d6a4f\"],[style*=\"background-color:#2d6a4f\"]{background-color:#1a1a1a !important;}[style*=\"color: #2d6a4f\"],[style*=\"color:#2d6a4f\"]{color:#1a1a1a !important;}#carbon-calc,#home-calc,#commute-tool,#compare-tool,#country-tool,#tree-calc,#biz-calc,#eco-tool,#esg-quiz,#event-tool,#wedding-tool,#audit-tool,#ppn-checker-tool{background:#f8f9fa;border-radius:12px;padding:24px;}.page-content input[type=number],.page-content input[type=text],.page-content select{border:1px solid #ddd !important;border-radius:6px !important;padding:10px 12px !important;font-size:0.95rem !important;width:100% !important;max-width:320px !important;box-sizing:border-box !important;}.page-content input[type=number]:focus,.page-content select:focus{border-color:#1a1a1a !important;outline:none !important;box-shadow:0 0 0 2px rgba(26,26,26,0.1) !important;}.page-content input[type=radio]{accent-color:#1a1a1a !important;}.page-content label{cursor:pointer;}";
  document.head.appendChild(css);
}

/* ===== CONSENT GATE ===== */
function injectConsent(containerEl, btn) {
  var wrap = document.createElement("div");
  wrap.className = "calc-consent-wrap";
  wrap.style.cssText =
    "margin:16px 0 8px;padding:14px 16px;" +
    "background:#ffffff !important;" +
    "border:1px solid #cfcfcf !important;" +
    "border-radius:8px;" +
    "box-shadow:0 1px 2px rgba(0,0,0,0.06);" +
    "opacity:1 !important;filter:none !important;" +
    "color:#1a1a1a !important;";

  wrap.innerHTML =
    '<label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;' +
      'font-size:13px;line-height:1.5;color:#1a1a1a !important;font-weight:500;' +
      'opacity:1 !important;filter:none !important;margin:0;">' +
      '<input type="checkbox" class="calc-consent" ' +
        'style="margin-top:3px;width:18px;height:18px;flex-shrink:0;' +
        'accent-color:#1a1a1a;cursor:pointer;opacity:1 !important;filter:none !important;">' +
      '<span style="color:#1a1a1a !important;opacity:1 !important;filter:none !important;">' +
        'By using this calculator, you agree to our ' +
        '<a href="https://www.offsetbritain.org/policies/terms-of-service" target="_blank" ' +
          'style="color:#1a1a1a !important;text-decoration:underline;font-weight:600;">Terms of Service</a>' +
        ' and consent to receiving follow-up communications about your carbon footprint results. ' +
        'You can unsubscribe at any time. See our ' +
        '<a href="https://www.offsetbritain.org/policies/privacy-policy" target="_blank" ' +
          'style="color:#1a1a1a !important;text-decoration:underline;font-weight:600;">Privacy Policy</a>.' +
      '</span>' +
    '</label>';

  btn.parentNode.insertBefore(wrap, btn);

  var cb = wrap.querySelector(".calc-consent");
  btn.disabled = true;
  btn.style.opacity = "0.5";
  btn.style.cursor = "not-allowed";
  cb.addEventListener("change", function () {
    btn.disabled = !cb.checked;
    btn.style.opacity = cb.checked ? "1" : "0.5";
    btn.style.cursor = cb.checked ? "pointer" : "not-allowed";
  });
}

function init() {
  fixColors();
  populateCountries();
  var b = [
    {c:"carbon-calc",f:calcCarbon},
    {c:"home-calc",f:calcHomeEnergy},
    {c:"commute-tool",f:calcCommute},
    {c:"compare-tool",f:calcCompare},
    {c:"country-tool",f:calcCountry},
    {c:"tree-calc",f:calcTrees},
    {c:"biz-calc",f:calcBusiness},
    {c:"eco-tool",f:calcEco},
    {c:"esg-quiz",f:calcESG},
    {c:"event-tool",f:calcEvent},
    {c:"wedding-tool",f:calcWedding},
    {c:"audit-tool",f:calcOffice},
    {c:"ppn-checker-tool",f:calcPPN}
  ];
  b.forEach(function(x) {
    var el = document.getElementById(x.c);
    if (!el) return;
    var btn = el.querySelector("button");
    if (btn) {
      injectConsent(el, btn);
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        x.f();
      });
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

})();